export const features = [
  {
    featureGroupTitle: '',
    features: [
      {
        title: 'Services & fees'
      },
      {
        title: 'Arrivals & In-house'
      },
      {
        title: 'Bookings'
      }
    ]
  },
  {
    featureGroupTitle: 'Analytics',
    features: [
      {
        title: 'Subscribers'
      },
      {
        title: 'Outreach'
      },
      {
        title: 'OTA Outreach'
      },
      {
        title: 'Conversions'
      },
      {
        title: 'Reviews'
      }
    ]
  },
  {
    featureGroupTitle: 'Messaging',
    features: [
      {
        title: 'In-property messaging'
      },
      {
        title: 'Chatbot'
      },
      {
        title: 'Announcements'
      }
    ]
  },
  {
    featureGroupTitle: 'Automated Messages',
    features: [
      {
        title: 'Campaigns'
      },
      {
        title: 'OTA Campaigns'
      }
    ]
  }
]
